import { FC, useCallback, useEffect, useRef, useState } from 'react';

interface ITextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  invalid?: boolean;
  width?: string;
  bgColor?: string;
  borderColor?: string;
}

export const TextInputWithSign: FC<ITextInputProps> = ({
  value,
  onChange,
  placeholder = '',
  invalid = false,
  width = '150px',
  bgColor = '#141316',
  borderColor = '#2B292F',
}) => {
  const [inputFocus, setInputFocus] = useState(false);
  const textInput = useRef<HTMLInputElement>(null);

  const onBlur = useCallback(() => {
    if (value && value.length) return;
    setInputFocus(false);
  }, [value]);

  useEffect(() => {
    if (!value) {
      setInputFocus(false);
    }
  }, [value]);

  const onClick = () => {
    setInputFocus(true);
    textInput?.current?.click();
    textInput?.current?.focus();
  };

  return (
    <div
      style={{
        minWidth: width,
        maxWidth: width,
      }}
      className={`h-[33px] w-full gap-2 rounded-[8px] bg-[${bgColor}] px-[10px] flex items-center  ${invalid ? 'border border-solid border-[#E23336]' : ``}`}
    >
      <div
        style={{
          minWidth: '12px',
          minHeight: '12px',
          maxWidth: '12px',
          maxHeight: '12px',
        }}
        className={`w-[12px] h-[12px] bg-[#4598E6] rounded-[4px]`}
      />
      <input
        onBlur={() => onBlur()}
        autoFocus={false}
        ref={textInput}
        value={value}
        className={`bg-[${bgColor}] text-[white] outline-none ${inputFocus || value ? 'w-full h-full' : 'w-[0px] h-[0px]'}`}
        onChange={({ target: { value } }) => onChange(value)}
      />

      <div
        onClick={() => onClick()}
        className={`bg-[${bgColor}] text-[#777777] ${!inputFocus && (!value || !value?.length) ? 'w-full h-full flex items-center' : 'hidden'}`}
      >
        {placeholder}
      </div>
    </div>
  );
};
